import { useState as u, useEffect as O } from "react";
var r = /* @__PURE__ */ ((i) => (i[i.ADD_NOTIFICATION = 0] = "ADD_NOTIFICATION", i[i.DISMISS_NOTIFICATION = 1] = "DISMISS_NOTIFICATION", i[i.POP_NOTIFICATION = 2] = "POP_NOTIFICATION", i[i.CLEAR_NOTIFICATIONS = 3] = "CLEAR_NOTIFICATIONS", i))(r || {});
const T = () => {
  setTimeout(() => {
    a({
      type: 2
      /* POP_NOTIFICATION */
    });
  }, 500);
}, S = (i, n) => {
  switch (n.type) {
    case 0: {
      const e = n.notification;
      return i.notifications.filter((l) => l.visible === !0) && (e.visible = !0), {
        ...i,
        notifications: [...i.notifications, e]
      };
    }
    case 1: {
      const e = [...i.notifications];
      return e.length > 0 && (e[0].visible = !1), e.length > 1 && (e[1].visible = !0), T(), {
        ...i,
        notifications: e
      };
    }
    case 2:
      let t = [...i.notifications];
      return i.notifications.length > 0 && i.notifications[0].visible === !1 && (t = t.slice(1)), {
        ...i,
        notifications: t
      };
    case 3:
      return {
        ...i,
        notifications: i.notifications.length > 0 ? [i.notifications[0]] : []
      };
  }
}, s = [];
let o = { notifications: [] };
const a = (i) => {
  o = S(o, i), s.forEach((n) => {
    n(o);
  });
}, A = () => {
  const [i, n] = u(o);
  return O(() => (s.push(n), () => {
    const t = s.indexOf(n);
    t > -1 && s.splice(t, 1);
  }), [i]), {
    notifications: i.notifications
  };
}, f = (i) => (n, t) => {
  const e = {
    message: n,
    duration: (t == null ? void 0 : t.duration) || 5e3,
    type: i,
    visible: !1,
    createdAt: Date.now(),
    action: t == null ? void 0 : t.action
  };
  (t == null ? void 0 : t.clear) === !0 && N(), a({
    type: r.ADD_NOTIFICATION,
    notification: e
  });
}, I = () => {
  a({
    type: r.DISMISS_NOTIFICATION
  });
}, N = () => {
  a({
    type: r.CLEAR_NOTIFICATIONS
  }), I();
}, c = (i, n) => f("success")(i, n);
c.error = f("error");
c.warning = f("warning");
c.success = f("success");
c.dismiss = I;
c.clear = N;
export {
  c as n,
  A as u
};
